import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect, useMemo } from "react";
import { ObraChecklistServicoCampos } from "../../../../domain/models/obra_checklist_servico_campos";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { zodResolver } from "@hookform/resolvers/zod";
import { InspecaoObraForm, InspecaoObraSchema } from "../../../schemas/ObraItensChecklistArea_cadastro/inspecao_obra";
import { InspecaoObra } from "../../../../domain/models/inspecao_obra";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import dayjs from "dayjs";

/**
 * InspecaoObraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectecInspecaoObra: InspecaoObra | null,
  obraChecklistServicoCampos: ObraChecklistServicoCampos | null,
  onClose: () => void;
  onSubmit: (form: InspecaoObraForm) => void;
};

export const InspecaoObraModal = ({
  open,
  saving,
  loading,
  selectecInspecaoObra,
  obraChecklistServicoCampos,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<InspecaoObraForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(InspecaoObraSchema),
  });

  const field1 = useMemo(() => {
    return obraChecklistServicoCampos?.labelCampo1 ?? null;
  }, [
    obraChecklistServicoCampos,
  ]);

  const field2 = useMemo(() => {
    return obraChecklistServicoCampos?.labelCampo2 ?? null;
  }, [
    obraChecklistServicoCampos,
  ]);

  const field3 = useMemo(() => {
    return obraChecklistServicoCampos?.labelCampo3 ?? null;
  }, [
    obraChecklistServicoCampos,
  ]);

  const field4 = useMemo(() => {
    return obraChecklistServicoCampos?.labelCampo4 ?? null;
  }, [
    obraChecklistServicoCampos,
  ]);

  useEffect(() => {
    if (open) {
      if (selectecInspecaoObra && obraChecklistServicoCampos) {
        hookForm.setValue('data', dayjs(selectecInspecaoObra.dataAbertura).toDate());

        if (obraChecklistServicoCampos.labelCampo1) {
          hookForm.setValue('campo1', selectecInspecaoObra.campo1);
        } else {
          hookForm.resetField('campo1');
        }

        if (obraChecklistServicoCampos.labelCampo2) {
          hookForm.setValue('campo2', selectecInspecaoObra.campo2);
        } else {
          hookForm.resetField('campo2');
        }

        if (obraChecklistServicoCampos.labelCampo3) {
          hookForm.setValue('campo3', selectecInspecaoObra.campo3);
        } else {
          hookForm.resetField('campo3');
        }

        if (obraChecklistServicoCampos.labelCampo4) {
          hookForm.setValue('campo4', selectecInspecaoObra.campo4);
        } else {
          hookForm.resetField('campo4');
        }
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectecInspecaoObra,
    obraChecklistServicoCampos,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Verificação de Inspeção'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Data" arrangement="fullRow">
        <>
          <FormDatePickerInput
            name='data'
            label='Data'
            required={true}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
      {
        (field1 || field2 || field3 || field4) &&
        <FormContainer title="Critérios de Localização da Inspeção" arrangement="fullRow">
          <>
            {
              field1 &&
              <DefaultFormInput
                name='campo1'
                label={field1}
                reactHookForm={hookForm}
              />
            }
            {
              field2 &&
              <DefaultFormInput
                name='campo2'
                label={field2}
                reactHookForm={hookForm}
              />
            }
            {
              field3 &&
              <DefaultFormInput
                name='campo3'
                label={field3}
                reactHookForm={hookForm}
              />
            }
            {
              field4 &&
              <DefaultFormInput
                name='campo4'
                label={field4}
                reactHookForm={hookForm}
              />
            }
          </>
        </FormContainer>
      }
    </BaseFormControlledModal>
  );
}